import { NetworkAttackWebComponent } from './component/NetworkAttackWebComponent';
import { WEB_COMPONENT_WIDGET_NETWORK_ATTACK_TECHNIQUES } from '../webcomponents.constants';

export { NetworkAttackWebComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_NETWORK_ATTACK_TECHNIQUES, NetworkAttackWebComponent);
